import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { CartCircleCheck, Close } from "../../../icons";

type TableGridCellProps = {
  availableQty: number;
  onClick?: () => void;
  selectedQty: any[];
};
export const TableGridCell = ({
  availableQty,
  selectedQty,
  onClick,
}: TableGridCellProps) => {
  const theme = useTheme();
  return (
    <Box display="flex" justifyContent="center">
      <Box
        sx={{
          position: "absolute",
          left: 5,
          top: 5,
        }}
      >
        <CartCircleCheck
          sx={{
            width: 17,
            height: 17,
          }}
          htmlColor={theme.palette.success.main}
        />
      </Box>
      <IconButton
        sx={{
          backgroundColor: theme.palette.primary[100],
          padding: "3px",
          borderRadius: "100vmax !important",
          position: "absolute",
          right: 2,
          top: 2,
        }}
        onClick={onClick}
      >
        <Close
          htmlColor={theme.palette.primary[900]}
          sx={{
            width: 13,
            height: 13,
          }}
        />
      </IconButton>

      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          left: 5,
          bottom: 5,
          userSelect: "none",
          opacity: 0.7,
          color:
            availableQty > 0
              ? theme.palette.success.main
              : theme.palette.warning.main,
        }}
      >
        Ord:({selectedQty})
      </Typography>
    </Box>
  );
};
